<template>
    <v-container colum fluid fill-height v-if="supplierId">
        <v-row>
            <v-col>
                <v-btn text to="/inventory/suppliers">
                    <v-icon left>mdi-arrow-left</v-icon>Back
                </v-btn>
                <v-card>
                    <v-toolbar color="secondary" dark>
                        <v-toolbar-title>
                            <v-icon left>mdi-handshake</v-icon>Supplier
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        {{model}}
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    components:{
    },
    data: () => ({
        model:null,
        loading:true,
        supplierId:null
    }),
    mounted(){
        if (this.$route.params.id) {
            this.supplierId = parseInt(this.$route.params.id);
            this.getSupplier()
        } else {
            this.$route.push("/inventory/suppliers");
        }
    },
    methods:{
        ...mapActions("supplier", {get:"view"}),
        getSupplier(){
            this.get(this.supplierId)
            .then(({supplier}) => {
                this.model = supplier
            })
            .finally(() => {
                this.loading=false
            })
        }
    }
    
}
</script>

<style>

</style>